import React, {useEffect, useState} from "react"
import {IPagesProps} from "../../../contracts/pages";
import Table from "../../Elements/Table";
import useToastNotify from "../../../hook/useToastNotify";
import TableTd from "../../Elements/Table/TableTd";
import Badge from "../../Elements/Badge";
import {badgeType} from "../../../constans/enumTypes";
import TableTr from "../../Elements/Table/TableTr";
import httpClient from "../../../services/httpClient";
import {usersApi} from "../../../constans/apiUrls";
import MyPagination from "../../Elements/MyPagination";
import TableTdContent from "../../Elements/Table/TableTdContent";
import TableEmpty from "../../Elements/Table/TableEmpty";
import {FiBookmark, FiEdit, FiVideo} from "react-icons/fi";
import {MdOutlineLoop} from "react-icons/md";
import MenuDrop from "../../Elements/MenuDrop";
import MenuDropItem from "../../Elements/MenuDrop/MenuDropItem";
import {useLocation} from "react-router-dom";
import {IUsersDataList} from "../../../contracts/data/user";
import {HiOutlineMail} from "react-icons/hi";
import {AiOutlineComment, AiOutlineHeart, AiOutlineStar} from "react-icons/ai";
import { BsBasket } from "react-icons/bs";
import { BiShoppingBag, BiWallet } from "react-icons/bi";

const ListUsers: React.FC<IPagesProps> = () => {
    const {toastNotify} = useToastNotify()
    const location = useLocation()
    const [data, setData] = useState<Array<IUsersDataList>>([]);
    const [page, setPage] = useState<number>(1);
    const [countItems, setCountItems] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [reload, setReload] = useState<boolean>(false);

    const titleHeadTable: Array<string> = ['#', 'نام و نام خانوادگی', 'شماره موبایل', 'تاریخ عضویت', 'وضعیت','عملیات']

    const fetchItemsData = async (search: string | null | undefined = "") => {
        await httpClient().get(`${usersApi.list}?page=${page}`, {params: {search}})
            .then(response => {
                if(response.status === 200){
                    setCountItems(response.data.count)
                    setData(response?.data?.results)
                }
            })
            .catch(error => toastNotify('error', 'مشکلی در دریافت لیست آیتم ها وجود دارد'))
            .finally(() => setLoading(false))
    }

    const handleSearchItems = async (search: string | null | undefined = "") => {
        setLoading(true)
        setPage(1)
        fetchItemsData(search)
    }

    const handleChangeStatusItem = async (id: number, index: number) => {
        await httpClient().put(usersApi.status, {user: id})
            .then(response => {
                if(response.status === 200){
                    data[index].is_active = !data[index].is_active
                    setReload(true)
                }
            })
            .catch(error => {console.log(error)})
    }

    useEffect(() => {
        fetchItemsData()
    }, [page])

    useEffect(() => {
        if (reload) {
            setReload(false)
        }
    }, [reload])

    const itemsTableRows = data.map((item, index) =>
        <TableTr key={`table-row${index}`}>
            <TableTd><TableTdContent content={`${index + 1}`}/></TableTd>
            <TableTd><TableTdContent content={`${item?.info?.first_name} ${item?.info?.last_name}`} isPrimary/></TableTd>
            <TableTd><TableTdContent content={item?.mobile}/></TableTd>
            <TableTd><TableTdContent content={item?.date_joined_jalali?.split(",")[1]}/></TableTd>
            <TableTd>
                <Badge title={item?.is_active ? "فعال" : "غیرفعال"}
                       typeBadge={item?.is_active ? badgeType.success : badgeType.error}/>
            </TableTd>
            <TableTd>
                <MenuDrop>
                    <MenuDropItem title={"پروفایل"} icon={<FiEdit/>}  isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/users/profile',
                        search: `?id=${item?.id}`,
                        state: {page: location.pathname, page_num: page}
                    }}/>
                    <MenuDropItem title={"خرید ها"} icon={<BiShoppingBag/>}  isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/users/purchases',
                        search: `?id=${item?.id}&name=${item?.info?.first_name} ${item?.info?.last_name}`,
                        state: {page: location.pathname, page_num: page}
                    }}/>
                    <MenuDropItem title={"محصولات ویدیویی"} icon={<FiVideo/>}  isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/users/videos-products',
                        search: `?id=${item?.id}&name=${item?.info?.first_name} ${item?.info?.last_name}`,
                        state: {page: location.pathname, page_num: page}
                    }}/>
                    <MenuDropItem title={"سبد خرید"} icon={<BsBasket/>}  isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/users/basket',
                        search: `?id=${item?.id}&name=${item?.info?.first_name} ${item?.info?.last_name}`,
                        state: {page: location.pathname, page_num: page}
                    }}/>
                    <MenuDropItem title={"کیف پول"} icon={<BiWallet/>}  isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/users/wallet',
                        search: `?id=${item?.id}&name=${item?.info?.first_name} ${item?.info?.last_name}`,
                        state: {page: location.pathname, page_num: page}
                    }}/>
                    <MenuDropItem title={"تیکت ها"} icon={<HiOutlineMail/>}  isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/users/tickets',
                        search: `?id=${item?.id}&name=${item?.info?.first_name} ${item?.info?.last_name}`,
                        state: {page: location.pathname, page_num: page}
                    }}/>
                    <MenuDropItem title={"نظرات"} icon={<AiOutlineComment/>}  isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/users/comments',
                        search: `?id=${item?.id}&name=${item?.info?.first_name} ${item?.info?.last_name}`,
                        state: {page: location.pathname, page_num: page}
                    }}/>
                    <MenuDropItem title={"علاقه مندی ها"} icon={<FiBookmark/>}  isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/users/favorites',
                        search: `?id=${item?.id}&name=${item?.info?.first_name} ${item?.info?.last_name}`,
                        state: {page: location.pathname, page_num: page}
                    }}/>
                    <MenuDropItem title={"امتیازات"} icon={<AiOutlineStar/>}  isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/users/rates',
                        search: `?id=${item?.id}&name=${item?.info?.first_name} ${item?.info?.last_name}`,
                        state: {page: location.pathname, page_num: page}
                    }}/>
                    <MenuDropItem title={"لایک ها"} icon={<AiOutlineHeart/>}  isLinkBtn urlLinkProps={{
                        pathname: '/dashboard/users/likes',
                        search: `?id=${item?.id}&name=${item?.info?.first_name} ${item?.info?.last_name}`,
                        state: {page: location.pathname, page_num: page}
                    }}/>
                    <MenuDropItem title={"تغییر وضعیت"} icon={<MdOutlineLoop/>}
                                  handleOnSubmit={() => handleChangeStatusItem(item?.id, index)}/>
                </MenuDrop>
            </TableTd>
        </TableTr>
    )

    return (
        <React.Fragment>
            <Table isLoading={loading} title={'لیست کاربران'} subTitle={`تعداد کل: ${countItems}`}
                   titlesTable={titleHeadTable} isSearch={true} handleSearch={handleSearchItems}>
                {itemsTableRows.length > 0 ? itemsTableRows :
                    <TableEmpty colSpan={titleHeadTable.length} message={"کاربری یافت نشد"}/>}
            </Table>
            <div className={"text-right"}>
                <MyPagination countItems={countItems} page={page} handleChangePage={setPage}/>
            </div>
        </React.Fragment>
    )
}

export default ListUsers